const MONTH_DAY: Intl.DateTimeFormatOptions = {
	month: "short",
	day: "numeric",
	timeZone: "UTC",
}

export const formatUtcMonthDay = (date: Date) =>
	date.toLocaleDateString("en-US", MONTH_DAY)

// The window a weekly bucket covers, spelled out for a tooltip: an axis tick
// only has room for where the week starts. "Aug 24 - 30, 2026".
export const formatUtcWeekRange = (start: Date) => {
	const end = new Date(start)
	end.setUTCDate(end.getUTCDate() + 6)
	const sameYear = start.getUTCFullYear() === end.getUTCFullYear()
	const sameMonth = sameYear && start.getUTCMonth() === end.getUTCMonth()

	const startText = sameYear
		? formatUtcMonthDay(start)
		: `${formatUtcMonthDay(start)}, ${start.getUTCFullYear()}`
	const endText = sameMonth ? String(end.getUTCDate()) : formatUtcMonthDay(end)

	return `${startText} - ${endText}, ${end.getUTCFullYear()}`
}
